/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Detail_Empty_Month_BodyInputs */



/**
* | output |
* | --- |
* | "A period appears in the month it closes in. None closed here." |
*
* @param {Partner_Detail_Empty_Month_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_empty_month_body = /** @type {((inputs?: Partner_Detail_Empty_Month_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Empty_Month_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Zeitraum erscheint in dem Monat, in dem er endet. Hier endete keiner.")
	return /** @type {LocalizedString} */ ("A period appears in the month it closes in. None closed here.")
});